export default "__VITE_ASSET__Cuxhdei6__"